/* La Troupe / LLCL Collection PLP V6.0 */
(()=>{
  const SECTION='.shopify-section--main-collection';
  const SIDEBAR=`${SECTION} .facets-sidebar`;
  const CARD=`${SECTION} product-card.product-card`;
  const MAX_VISIBLE_SWATCHES=5;
  const DESKTOP=window.matchMedia('(min-width: 1000px)');
  let scheduled=false;

  const COLOR_FALLBACKS=Object.freeze({
    black:'#121212',
    negro:'#121212',
    white:'#f7f6f1',
    blanco:'#f7f6f1',
    ivory:'#efe8d8',
    marfil:'#efe8d8',
    cream:'#e4d7c0',
    crema:'#e4d7c0',
    beige:'#c8b79a',
    cement:'#aaa59d',
    cemento:'#aaa59d',
    gray:'#8d8e8b',
    grey:'#8d8e8b',
    gris:'#8d8e8b',
    lead:'#696e72',
    plomo:'#696e72',
    gold:'#b18b4d',
    dorado:'#b18b4d',
    mustard:'#b38a32',
    mostaza:'#b38a32',
    burgundy:'#682b36',
    wine:'#682b36',
    guinda:'#682b36',
    pink:'#d7aaa9',
    rosa:'#d7aaa9',
    salmon:'#d97d6d',
    salmonado:'#d97d6d',
    vanilla:'#e8dcba',
    vainilla:'#e8dcba',
    blue:'#708397',
    azul:'#708397',
    navy:'#27394a',
    marino:'#27394a',
    green:'#72806b',
    verde:'#72806b',
    olive:'#77785a',
    oliva:'#77785a',
    brown:'#775944',
    cafe:'#775944',
    camel:'#a9855d',
    terracotta:'#a55f49',
    terracota:'#a55f49',
    red:'#a23c35',
    rojo:'#a23c35',
    orange:'#c8784b',
    naranja:'#c8784b',
    yellow:'#d1b651',
    amarillo:'#d1b651',
    purple:'#74627d',
    morado:'#74627d',
    lilac:'#b5a4b7',
    lila:'#b5a4b7',
    turquoise:'#709b99',
    turquesa:'#709b99'
  });

  const makeSpan=(className,text='')=>{
    const el=document.createElement('span');
    el.className=className;
    el.textContent=text;
    return el;
  };

  const normalizeLabel=value=>String(value||'')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g,'')
    .trim()
    .toLowerCase();

  const language=()=>String(document.documentElement.lang||'en').toLowerCase();

  const viewCopy=()=>{
    const lang=language();
    if(lang.startsWith('es'))return{label:'Vista',roomy:'Vista amplia',compact:'Vista compacta'};
    if(lang.startsWith('fr'))return{label:'Vue',roomy:'Vue ample',compact:'Vue compacte'};
    return{label:'View',roomy:'Roomy view',compact:'Compact view'};
  };

  const config=()=>{
    const root=document.querySelector('[data-ll-v3-card-data]');
    const map=new Map();
    if(!root){
      return{
        map,
        collection:'',
        filterHeading:'Filter by',
        priceLabel:'Price',
        availabilityLabel:'Availability',
        sizeLabel:'Size'
      };
    }

    root.querySelectorAll('[data-handle]').forEach(el=>{
      map.set(el.dataset.handle,{
        type:el.dataset.type||'',
        sizes:[...el.querySelectorAll('[data-size]')]
          .map(node=>node.dataset.size)
          .filter(Boolean)
      });
    });

    return{
      map,
      collection:root.dataset.collection||'',
      filterHeading:root.dataset.filterHeading||'Filter by',
      priceLabel:root.dataset.priceLabel||'Price',
      availabilityLabel:root.dataset.availabilityLabel||'Availability',
      sizeLabel:root.dataset.sizeLabel||'Size'
    };
  };

  const associatedInput=label=>{
    if(!label?.htmlFor)return null;
    const candidate=document.getElementById(label.htmlFor);
    return candidate instanceof HTMLInputElement?candidate:null;
  };

  /* --------------------------------------------------------
     Product cards
     -------------------------------------------------------- */
  /* LLCL V2: preserve every color choice, including sold-out native states.
     No arbitrary five-swatch cutoff or synthetic +N that hides inputs. */
  // Card presentation and variant selection are now owned by ll-product-reveal.js.
  const enhanceCards=()=>{};

  const paintColorChip=(swatch,chip,label,canReadComputed)=>{
    let painted=false;

    if(canReadComputed){
      const computed=getComputedStyle(swatch);
      const image=computed.backgroundImage;
      const color=computed.backgroundColor;

      if(image&&image!=='none'){
        chip.style.backgroundImage=image;
        chip.style.backgroundColor='transparent';
        painted=true;
      }else if(color&&color!=='transparent'&&color!=='rgba(0, 0, 0, 0)'){
        chip.style.backgroundColor=color;
        chip.style.backgroundImage='none';
        painted=true;
      }
    }

    if(!painted){
      const fallback=COLOR_FALLBACKS[normalizeLabel(label)];
      if(fallback){
        chip.style.background=fallback;
        painted=true;
      }
    }

    if(!painted){
      const raw=swatch.style.getPropertyValue('--swatch-background').trim();
      if(raw){
        chip.style.setProperty('--ll-swatch-background',raw);
      }else{
        chip.style.background='repeating-linear-gradient(135deg,#d8d5ce 0 3px,#efede8 3px 6px)';
      }
    }
  };

  const enhanceColorOptions=(scope=document)=>{
    scope.querySelectorAll(`${SIDEBAR} .color-swatch, #facets-drawer .color-swatch`).forEach(swatch=>{
      const wasEnhanced=swatch.classList.contains('ll-v4-color-option');
      const srLabel=swatch.querySelector('.sr-only')?.textContent?.trim();
      const label=swatch.dataset.tooltip?.trim()||srLabel;
      if(!label)return;

      let chip=swatch.querySelector('.ll-v4-color-chip');
      let text=swatch.querySelector('.ll-v4-color-label');

      if(!chip){
        chip=makeSpan('ll-v4-color-chip');
        chip.setAttribute('aria-hidden','true');
      }

      if(!text){
        text=makeSpan('ll-v4-color-label',label);
        text.setAttribute('aria-hidden','true');
      }else{
        text.textContent=label;
      }

      /* Read the native painted swatch before making the parent transparent. */
      paintColorChip(swatch,chip,label,!wasEnhanced);

      if(!wasEnhanced){
        swatch.classList.add('ll-v4-color-option');
      }

      if(!chip.isConnected||!text.isConnected){
        swatch.append(chip,text);
      }
    });
  };

  /* --------------------------------------------------------
     Desktop toolbar mount. Removes the overlay architecture:
     the native facet engine becomes a real toolbar child.
     -------------------------------------------------------- */
  const viewIcon=mode=>mode==='compact'
    ?'<svg class="ll-v6-view-icon" viewBox="0 0 20 20" aria-hidden="true"><rect x="2" y="2" width="6.5" height="6.5"/><rect x="11.5" y="2" width="6.5" height="6.5"/><rect x="2" y="11.5" width="6.5" height="6.5"/><rect x="11.5" y="11.5" width="6.5" height="6.5"/></svg>'
    :'<svg class="ll-v6-view-icon" viewBox="0 0 20 20" aria-hidden="true"><rect x="2" y="3" width="4" height="14"/><rect x="8" y="3" width="4" height="14"/><rect x="14" y="3" width="4" height="14"/></svg>';

  const syncViewSwitch=layoutSwitch=>{
    const targetId=layoutSwitch.getAttribute('aria-controls');
    const target=targetId?document.getElementById(targetId):null;
    const current=target?.getAttribute('collection-desktop-layout')||'medium';

    layoutSwitch.querySelectorAll('[data-ll-view-mode]').forEach(button=>{
      const active=button.dataset.llViewMode===current;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',active?'true':'false');
    });
  };

  const upgradeViewSwitch=layoutSwitch=>{
    if(!layoutSwitch)return;

    const copy=viewCopy();
    layoutSwitch.dataset.llViewSwitch='true';

    /* Keep the current 3-up mode and the denser 4-up mode. */
    const large=layoutSwitch.querySelector('button[value="large"]');
    if(large)large.hidden=true;

    const medium=layoutSwitch.querySelector('button[value="medium"]');
    const compact=layoutSwitch.querySelector('button[value="compact"]');

    if(!layoutSwitch.querySelector('.ll-v6-view-label')){
      layoutSwitch.prepend(makeSpan('ll-v6-view-label',copy.label));
    }

    if(medium){
      medium.dataset.llViewMode='medium';
      medium.setAttribute('aria-label',copy.roomy);
      medium.setAttribute('title',copy.roomy);
      if(medium.dataset.llV6Icon!=='true'){
        medium.innerHTML=viewIcon('medium');
        medium.dataset.llV6Icon='true';
      }
    }

    if(compact){
      compact.dataset.llViewMode='compact';
      compact.setAttribute('aria-label',copy.compact);
      compact.setAttribute('title',copy.compact);
      if(compact.dataset.llV6Icon!=='true'){
        compact.innerHTML=viewIcon('compact');
        compact.dataset.llV6Icon='true';
      }
    }

    if(layoutSwitch.dataset.llV6Bound!=='true'){
      layoutSwitch.dataset.llV6Bound='true';
      layoutSwitch.addEventListener('click',event=>{
        const button=event.target.closest('[data-ll-view-mode]');
        if(!button||!layoutSwitch.contains(button))return;

        const targetId=layoutSwitch.getAttribute('aria-controls');
        const target=targetId?document.getElementById(targetId):null;
        const mode=button.dataset.llViewMode;
        if(target&&mode){
          target.setAttribute('collection-desktop-layout',mode);
        }

        syncViewSwitch(layoutSwitch);
        requestAnimationFrame(()=>syncViewSwitch(layoutSwitch));
      });
    }

    syncViewSwitch(layoutSwitch);
  };

  const mountDesktopToolbar=()=>{
    if(!DESKTOP.matches)return;

    document.querySelectorAll(`${SECTION} .collection-toolbar`).forEach(toolbar=>{
      const section=toolbar.closest(SECTION);
      if(!section)return;

      toolbar.classList.add('ll-v6-toolbar');

      const sidebar=section.querySelector('.collection > .facets-sidebar, .collection-toolbar > .facets-sidebar');
      const buttonList=toolbar.querySelector('.collection-toolbar__button-list');

      if(sidebar){
        sidebar.dataset.llFilterToolbar='true';
        if(sidebar.parentElement!==toolbar){
          toolbar.insertBefore(sidebar,buttonList||toolbar.firstChild);
        }
      }

      const desktopSwitch=toolbar.querySelector('collection-layout-switch[device="desktop"]');
      upgradeViewSwitch(desktopSwitch);
    });
  };

  /* --------------------------------------------------------
     Facet state / dropdown behavior
     -------------------------------------------------------- */
  const selectedCount=panel=>panel.querySelector('price-range')
    ?[...panel.querySelectorAll('input[type="number"]')].some(input=>input.value!=='')?1:0
    :panel.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').length;

  const updateFilterState=details=>{
    const panel=details.querySelector(':scope > .accordion__content');
    const toggle=details.querySelector(':scope > summary .accordion__toggle');
    if(!panel||!toggle)return;

    toggle.querySelector('.ll-v3-filter-count')?.remove();
    const count=selectedCount(panel);
    details.dataset.llActive=count>0?'true':'false';

    if(count>0){
      const counter=makeSpan('ll-v3-filter-count',String(count));
      const icon=toggle.querySelector('svg, .animated-plus');
      icon?toggle.insertBefore(counter,icon):toggle.append(counter);
    }
  };

  const setLabel=(details,label)=>{
    const labelNode=details.querySelector(':scope > summary .accordion__toggle > span:first-child');
    if(labelNode&&label)labelNode.textContent=label;
  };

  const closeDetails=details=>{
    if(!details.open)return;
    details.open=false;
    details.setAttribute('aria-expanded','false');
  };

  const closeSidebar=(sidebar,except=null)=>{
    sidebar.querySelectorAll('.accordion__disclosure[open]').forEach(details=>{
      if(details!==except)closeDetails(details);
    });
  };

  const preserveViewport=details=>{
    if(!DESKTOP.matches)return;
    const remembered=details.__llPointerViewport;
    const lock={
      x:remembered?.x??window.scrollX,
      y:remembered?.y??window.scrollY,
      until:performance.now()+420
    };
    details.__llViewportLock=lock;

    const restore=()=>{
      if(performance.now()>lock.until)return;
      if(Math.abs(window.scrollY-lock.y)>1||Math.abs(window.scrollX-lock.x)>1){
        window.scrollTo(lock.x,lock.y);
      }
    };

    requestAnimationFrame(()=>{
      restore();
      requestAnimationFrame(restore);
    });
    window.setTimeout(restore,70);
    window.setTimeout(restore,180);
    window.setTimeout(restore,320);
  };

  const bindFacetSummary=details=>{
    const summary=details.querySelector(':scope > summary');
    if(!summary||summary.dataset.llV6Bound==='true')return;

    summary.dataset.llV6Bound='true';
    summary.addEventListener('pointerdown',()=>{
      if(!DESKTOP.matches)return;
      details.__llPointerViewport={x:window.scrollX,y:window.scrollY};
    },{passive:true});

    summary.addEventListener('click',event=>{
      if(!DESKTOP.matches)return;
      event.stopPropagation();
      preserveViewport(details);
    });

    summary.addEventListener('keydown',event=>{
      if(!DESKTOP.matches||(event.key!=='Enter'&&event.key!==' '))return;
      details.__llPointerViewport={x:window.scrollX,y:window.scrollY};
    });
  };

  const enhanceFacets=()=>{
    const labels=config();

    document.querySelectorAll(SIDEBAR).forEach(sidebar=>{
      const list=sidebar.querySelector('.accordion-list');
      if(!list)return;

      if(!list.querySelector('.ll-v3-filter-heading')){
        list.prepend(makeSpan('ll-v3-filter-heading',labels.filterHeading));
      }

      [...list.querySelectorAll('.accordion__disclosure')].forEach(details=>{
        const panel=details.querySelector(':scope > .accordion__content');
        if(!panel)return;

        bindFacetSummary(details);

        if(details.dataset.llV6FacetBound!=='true'){
          details.dataset.llV6FacetBound='true';
          if(panel.querySelector('price-range'))setLabel(details,labels.priceLabel);
          if(panel.querySelector('input[name="filter.v.availability"]'))setLabel(details,labels.availabilityLabel);
          details.open=false;
          details.setAttribute('aria-expanded','false');
          updateFilterState(details);

          details.addEventListener('toggle',()=>{
            details.setAttribute('aria-expanded',details.open?'true':'false');
            if(details.open){
              closeSidebar(sidebar,details);
              preserveViewport(details);
            }
          });

          panel.addEventListener('change',()=>updateFilterState(details));
          panel.addEventListener('input',()=>updateFilterState(details));
        }else{
          updateFilterState(details);
        }
      });
    });
  };

  const enhance=()=>{
    scheduled=false;
    mountDesktopToolbar();
    enhanceCards();
    enhanceFacets();
    enhanceColorOptions();
    document.querySelectorAll(`${SECTION} collection-layout-switch[device="desktop"]`).forEach(syncViewSwitch);
  };

  const schedule=()=>{
    if(scheduled)return;
    scheduled=true;
    requestAnimationFrame(enhance);
  };

  document.addEventListener('pointerdown',event=>{
    document.querySelectorAll(SIDEBAR).forEach(sidebar=>{
      if(!sidebar.contains(event.target))closeSidebar(sidebar);
    });
  },true);

  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    document.querySelectorAll(SIDEBAR).forEach(sidebar=>{
      const open=sidebar.querySelector('.accordion__disclosure[open]');
      const summary=open?.querySelector(':scope > summary');
      closeSidebar(sidebar);
      summary?.focus({preventScroll:true});
    });
  });

  DESKTOP.addEventListener?.('change',schedule);

  const observerRoot=document.body;
  if(observerRoot){
    new MutationObserver(schedule).observe(observerRoot,{childList:true,subtree:true});
  }

  schedule();
})();

